var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.66666 3.74995C1.66666 3.41843 1.79208 3.10048 2.01534 2.86606C2.2386 2.63164 2.5414 2.49995 2.85713 2.49995H17.1428C17.4586 2.49995 17.7614 2.63164 17.9846 2.86606C18.2079 3.10048 18.3333 3.41843 18.3333 3.74995C18.3333 4.08147 18.2079 4.39941 17.9846 4.63383C17.7614 4.86825 17.4586 4.99995 17.1428 4.99995H2.85713C2.5414 4.99995 2.2386 4.86825 2.01534 4.63383C1.79208 4.39941 1.66666 4.08147 1.66666 3.74995ZM4.28993 9.99995C4.28993 9.66843 4.41535 9.35048 4.63861 9.11606C4.86187 8.88164 5.16467 8.74995 5.4804 8.74995H14.5775C14.8932 8.74995 15.196 8.88164 15.4193 9.11606C15.6425 9.35048 15.7679 9.66843 15.7679 9.99995C15.7679 10.3315 15.6425 10.6494 15.4193 10.8838C15.196 11.1182 14.8932 11.2499 14.5775 11.2499H5.4804C5.16467 11.2499 4.86187 11.1182 4.63861 10.8838C4.41535 10.6494 4.28993 10.3315 4.28993 9.99995ZM7.34969 16.4152C7.34969 16.0837 7.47512 15.7658 7.69837 15.5313C7.92163 15.2969 8.22443 15.1652 8.54017 15.1652H11.52C11.8358 15.1652 12.1386 15.2969 12.3618 15.5313C12.5851 15.7658 12.7105 16.0837 12.7105 16.4152C12.7105 16.7467 12.5851 17.0647 12.3618 17.2991C12.1386 17.5335 11.8358 17.6652 11.52 17.6652H8.54017C8.22443 17.6652 7.92163 17.5335 7.69837 17.2991C7.47512 17.0647 7.34969 16.7467 7.34969 16.4152Z",
  fill: "#006FFD"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_953_2886)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.00326538,
  y: -0.000686646,
  width: 20,
  height: 20,
  fill: "#C9A46D"
}));

function SvgFilterGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_953_2886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 18,
    height: 16
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGold);
export default __webpack_public_path__ + "static/media/filter-gold.c08b560d.svg";
export { ForwardRef as ReactComponent };